export default "__VITE_ASSET__BmmzuFN9__"